import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import AbstractUserMediaPermissionsOverlay, { abstractMapStateToProps } from './AbstractUserMediaPermissionsOverlay';
import CustomOverlayFrame from './CustomOverlayFrame';
import BackgroundDesktop from './BackgroundDesktop';
import BackgroundMobile from './BackgroundMobile';
import { isMobileBrowser } from '../../../base/environment/utils';
/**
 * Implements a React Component for overlay with guidance how to proceed with
 * gUM prompt.
 */
class UserMediaPermissionsOverlay extends AbstractUserMediaPermissionsOverlay {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { t } = this.props;
        const langStringDesktopRequestPermissionsPageDesc = t('startupoverlay.requestPermissions.desktop');
        const langStringMobileRequestPermissionsPageDesc = t('startupoverlay.requestPermissions.mobile');
        const isMobile = isMobileBrowser();
        const mobile = (React.createElement(CustomOverlayFrame, { style: { backgroundColor: 'f3f3f7' } },
            " ",
            React.createElement(BackgroundMobile, null),
            React.createElement("div", { className: 'background-mobile' },
                React.createElement("div", { className: 'user-media-permissions-mobile-overlay-body' }),
                React.createElement("div", { className: 'user-media-permissions-mobile-overlay-containerY' },
                    React.createElement("div", { className: 'user-media-permissions-mobile-overlay-containerX' },
                        React.createElement("div", { className: 'user-media-permissions-mobile-overlay-containerX-wrap' },
                            React.createElement("div", { className: 'user-media-permissions-desktop-overlay-compassLogoIcon' }),
                            React.createElement("div", { className: 'user-media-permissions-mobile-overlay-compassLogoText' }, "Compass"))),
                    React.createElement("div", { className: 'user-media-permissions-mobile-overlay-requestMediaPermissionsBlock' },
                        React.createElement("div", { className: 'user-media-permissions-mobile-overlay-requestMediaPermissionsText' }, langStringMobileRequestPermissionsPageDesc.split("\n").map((line, index) => (React.createElement("div", { key: index }, line)))))))));
        const desktop = (React.createElement(CustomOverlayFrame, { style: { backgroundColor: 'f3f3f7' } },
            " ",
            React.createElement(BackgroundDesktop, null),
            React.createElement("div", { className: 'user-media-permissions-desktop-overlay-body', style: {} }),
            React.createElement("div", { className: 'user-media-permissions-desktop-overlay-containerY' },
                React.createElement("div", { className: 'user-media-permissions-desktop-overlay-containerX' },
                    React.createElement("div", { style: { flexDirection: 'row', alignItems: 'center', display: 'flex', gap: '12px' } },
                        React.createElement("div", { className: 'user-media-permissions-desktop-overlay-compassLogoIcon' }),
                        React.createElement("div", { className: 'user-media-permissions-desktop-overlay-compassLogoText' }, "Compass"))),
                React.createElement("div", { className: 'user-media-permissions-desktop-overlay-requestMediaPermissionsBlock' },
                    React.createElement("div", { className: 'user-media-permissions-desktop-overlay-requestMediaPermissionsText' }, langStringDesktopRequestPermissionsPageDesc.split("\n").map((line, index) => (React.createElement("div", { key: index }, line))))))));
        return isMobile ? mobile : desktop;
    }
}
/**
 * Maps (parts of) the redux state to the React {@code Component} props.
 *
 * @param {Object} state - The redux state.
 * @param {Object} ownProps - The props passed to the component.
 * @returns {Object}
 */
function mapStateToProps(state) {
    const { premeetingBackground } = state['features/dynamic-branding'];
    return {
        ...abstractMapStateToProps(state),
        _premeetingBackground: premeetingBackground
    };
}
export default translate(connect(mapStateToProps)(UserMediaPermissionsOverlay));
